import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
    selector: '[agprInitiallyFocusable]',
    standalone: false
})
export class InitiallyFocusableDirective  implements AfterViewInit {

    /* eslint-disable @angular-eslint/no-input-rename */
    /**
     * ### Accessibility Usage
     * Use this directive when a control's focusability needs to be removed innitially
     * and such functionality is not provided by the common component, or an HTML element is used
     */
    @Input('agprInitiallyFocusable') initiallyFocusable: boolean;

    constructor(
        public el: ElementRef,
    ) {}

    ngAfterViewInit(): void {
        this.el.nativeElement.setAttribute('tabindex', this.initiallyFocusable ? '0' : '-1');
    }
}
